import { Component, Input, OnInit } from '@angular/core';
import { Page } from '@bloomreach/spa-sdk';
import { CardsService } from '@services/cards.service';
import { MediaCardGroupContents } from './media-card-group.interface';

@Component({
  selector: 'ft-media-card-group',
  templateUrl: './media-card-group.component.html',
})
export class MediaCardGroupComponent implements OnInit {
  /**
   * Bloomreach page object
   */
  @Input() page: Page;

  /**
   * Content block content
   */
  @Input() contentBlock: MediaCardGroupContents;

  constructor(private cardsService: CardsService) {
    /// Constructor placeholder
  }

  ngOnInit(): void {
    this.contentBlock = this.cardsService.formatDataForMediaCards(
      this.contentBlock,
      this.page
    );
  }
}
